import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AdminLinkPatternsNewRoute extends Route {
  // Services
  @service breadcrumb;

  // Hooks
  model() {
    return this.breadcrumb.findRouteModelOrCreateRecord('link-pattern');
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
